<template>
    <div style="display: inline;">
        <v-btn
            :color="color"
            small
            @click="click"
        >
            <span>
                <template v-if="isLoading">
                    <v-progress-circular indeterminate :width="2" :size="13"></v-progress-circular>
                    {{ waitingText }}
                </template>
                <template v-else>
                    {{ text }}
                </template>
                <v-icon small right>{{icon}}</v-icon>
            </span>

        </v-btn>
    </div>
</template>

<script>
import WaitingMixin from 'fundation-app-vuejs/src/components/partials/waitingMixin';

export default {
    mixins: [WaitingMixin],
    components: {

    },

    props: {
        color: {
            type: String,
            required: false,
            default: 'success'
        },
        text: {
            type: String,
            required: true,
        },
        waitingText: {
            type: String,
            required: true,
        },
        clickAction: {
            type: Function,
            required: true,
        },
        action: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            required: false,
        },
    },

    data (){
        return {

        };
    },

    computed: {

    },

    mounted (){

    },

    methods: {
        click (){
            this.clickAction(this.action);
        }
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Partials/waiting-button.vue